import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {Validator} from 'vee-validate'
import Paginate from 'vuejs-paginate'
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'svcclosurep2p',
  components: {
      Paginate,
      VueElementLoading,
      Multiselect
  },
  data() {
    return {
      DepositDate: '',
      DeliveryDate: '',
      Deposit_Amount: '',
      DepositType: '',
      BankMasterId: '',
      TransactionID: '',
      DepositSlip: '',
      ReasonSlip: '',
      Reason: '',
      unmatchedAmt: 0,
      CODAmount: 0,
      tot_amt: 0,
      BankList: [],
      pageno: 0,
      pagecount: 0,
      localuserid: 0,
      localhubid: 0,
      localhubname: '',
      localhubzoneid: 0,
      DenominationList: [],
      StatusID: 0,
      FinanceConfirmAmount: 0,
      financeoutstanding:0,
      BatchID : '',
      DenominationArr: [],
      listSVCledgerData: [],
      ShipmentUpdateList: [],
      ReasonList: [],
      uploadFileList: [],
      reasonFileList: [],
      ReasonAmount: '',
      lowdisReason:'',
      carissAWBNo: '',
      cassnatAWBNo: '',
      paychgAWBNo: '',
      vendrecAWBNo: '',
      casstolAWBNo: '',
      theftstolAWBNo: '',
      wrongdelAWBNo: '',
      srabscAWBNo: '',
      nddissAWBNo: '',
      walissAWBNo: '',
      razissAWBNo: '',
      habridpiAWBNo: '',
      habridpiAMT: '',
      paypissAWBNo: '',
      srtpsrAmt: 0,
      srtptsvcAmt: '',
      carissReason: '',
      cassnatReason: '',
      paychgReason: '',
      vendrecReason: '',
      casstolReason: '',
      theftstolReason: '',
      wrongdelReason: '',
      srabscReason: '',
      srtpsrReason: '',
      srtptsvcReason: '',
      nddissReason: '',
      walissReason: '',
      razissReason: '',
      habridpiReason: '',
      paypissReason: '',
      CardAmount: 0,
      DisputeArr: [],
      cardM: 1,
      isLoading: false,
      bankLoading: [],
      DepositLoading: false,
      ReasonLoading: false,
      resultCount: 0,
      pendingCODAmt: 0,
      closingBalance: 0,
      yestClosingbalance: 0,
      yesterdayCODAmt: 0,
      twokdenominationscount:0,
      twokfreeze:false,
      TolatCollection: 0,
      p2pAmount: 0,
      myStr: '',
      resultdate: '',
      disableButton: false,
      modalShow:false,
      cardModalShow:false,
      ReasonModalShow:false,
      RecExcModalShow:false,
      penAmtLoading: false,
      denomLoading: false,
      exceptionLoading: false,
      exception:[],
      exceptionList:[],
      exceptionArr:[],
      exceptionAmount:0,
      lowdis:false,
      amoimp:false,
      vendrec:false,
      cassnat:false,
      cariss:false,
      paychg:false,
      casstol:false,
      theftstol:false,
      wrongdel:false,
      srabsc:false,
      srtpsr:false,
      srtptsvc:false,
      nddiss: false,
      waliss: false,
      raziss: false,
      habridpi: false,
      paypiss: false,
      modalAWBNoShow:false,
      awbnotype:'',
      awbnumber:'',
      expanded:false,
      subLoading:false,
      ExData:0,
      ExmodalShow:false,
      financeclosingamt:0,
      commentModalShow:false,
      comment:'',
      cType:'',
      ConfmodalShow:false,
      hideCM:1,
      role:'',
      todDate:'',
      resetdata:'',
      resetDD:'',
      ResetmodalShow:false,
      localhubIsRSC:false,
      RSCOwnerList:[],
      rscLoading:false,
      RSCOwner:'',
      isFnF:false,
      errorModalShow: false,
      errorTitle: '',
      errorMsg: '',
      cassnatAWBNoError : [],
      codAmountArr: [],
      awbnoStatusTabel: [],
      awbStatusModalShow: false,
      pendingClosureList: [],
      srtpsrPendingClosureList: [],
      srabscSRName: '',
      srtpSRName: '',
      srabscarr: [
        {         
          awbNo: '',
          srId: '',
          srName: ''
        }
      ],
      srtpsrarr: [
        {         
          srAmt: '',
          srId: '',
          srName: ''
        }
      ],
      cassnatarr: [
        {         
          awbNo: '',
          srId: '',
          srName: ''
        }
      ],
      lowdisAmt: '' ,
      srtptsvcfile: '',
      isCollapsed: 0,
      depositSlips: [
        {
          RSCOwner: '',
          DeliveryDate: '',
          DepositDate: '',
          Deposit_Amount: '',
          DepositType: '',
          BankList: [],
          BankMasterId: '',
          TransactionID: '',
          exception: '',
          exceptionAmount: '',
          DepositSlip: '',
          denominationList: [],
          uploadFileList: [],
          tot_amt: 0,
          DenominationArr: [],
          BatchID: ''
        }
      ],
      finalArray: [],
      expandedRows: [], // Object to track which rows are expanded
      pine:false,
      pineAWBNo:'',
      pineReason:'',
      totalSum: 0,
      srPenAmtLoading:false,
      inActiveBankIDs : [
        22,  // CMS - Yes BB - Cash Pickup 
        10,  //  RBL Bank - Cash Pickup  
        100, // Razorpay - IMPS
        32  // bank of india - self deposit type 
      ],
      fintechReason: '',
      fintech:false,
      fintechAmt: '',
      codRot:false,
      codRotReason:'',
      codRotAmt:'',
      loadingAwb:false ,
      debounceTimer: null,
      nonIsHybrid:[],
      invalidShipments:[],
      invalidShipmentsMsg: ''
    }
  },

  computed: {
    minDate() {
      var date = new Date();
      date.setDate(date.getDate() - 5);
      return date.toLocaleDateString('fr-CA', {year: 'numeric', month: '2-digit', day: '2-digit'});
    },
    maxDate() {
      var date = new Date();      
      return date.toLocaleDateString('fr-CA', {year: 'numeric', month: '2-digit', day: '2-digit'});
    },
  },
  created() {
    console.log('Build Success for Multislip!!');
  },
  async mounted() {
    console.log(process.env.NODE_ENV)
    this.role             = window.localStorage.getItem('accessrole').toLowerCase();

    var userdetailEncrypt = window.localStorage.getItem('accessuserdata')
    var bytes             = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext         = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail        = JSON.parse(plaintext);
    this.localuserid      = userdetail.username;

    var hubdetailEncrypt  = window.localStorage.getItem('accesshubdata')
    var bytes             = CryptoJS.AES.decrypt(hubdetailEncrypt.toString(), 'Key');
    var plaintext         = bytes.toString(CryptoJS.enc.Utf8);
    var hubdetail         = JSON.parse(plaintext);
    this.localhubid       = hubdetail[0].HubID;
    this.localhubname     = hubdetail[0].HubName;
    this.localhubzoneid   = hubdetail[0].HubZoneId;
    this.localhubIsRSC    = hubdetail[0].IsRSC;

    var userToken = window.localStorage.getItem('accessuserToken')
    this.myStr = userToken.replace(/"/g, '');

    var date = new Date();
    //DepositDate.max = DeliveryDate.max = date.toLocaleDateString('fr-CA', {year: 'numeric', month: '2-digit', day: '2-digit'});

    date.setDate(date.getDate() - 1);
    this.DeliveryDate = date.toLocaleDateString('fr-CA', {year: 'numeric', month: '2-digit', day: '2-digit'});

    this.depositSlips.forEach(element => {
         element['DeliveryDate'] = this.DeliveryDate
    });

    date.setDate(date.getDate() - 5);
    //DepositDate.min = date.toLocaleDateString('fr-CA', {year: 'numeric', month: '2-digit', day: '2-digit'});

    this.BatchID = this.localhubid+''+Math.floor(Math.random() * (Math.pow(10,5)));

    this.todDate = new Date().toLocaleDateString('fr-CA', {year: 'numeric', month: '2-digit', day: '2-digit'});

    await this.GetDenominationData();
    await this.GetSVCExceptionData();
    await this.GetReasonList();
    await this.GetSVCledgerData();
    await this.GetShipmentUpdate();
    await this.getSRList();
    if(this.localhubIsRSC) await this.getRSCOwnerData();
  },

  methods: {

    getSRAWBNo(awbNos, SRawbNos) {

      console.log('awbNos', awbNos)
      let acc = [];
      const SRawbNoarr = SRawbNos.split(",");
      console.log('SRawbNoarr', SRawbNoarr)

      const result = awbNos.reduce((acc, obj) => {
        Object.entries(obj).forEach(([key, value]) => {
          if (SRawbNoarr.includes(key)) {
            acc.push({ awbno: key, amount: value });
          }
        });
        return acc;
      }, []); // Initialize acc as an empty array

      console.log('result', result);
      return result;
    },

    toggleDetails(reasonId) {
      // Toggle the expanded state for the given row index
     this.$set(this.expandedRows, reasonId, !this.expandedRows[reasonId]);
    },
    
    getVisibleSRDetails(reasonId,details) {
      let data = [];
      // Show only the first record if not expanded
      data = this.expandedRows[reasonId] ? details : details.slice(0, 1);

      return data;
    },

    multiple(){
      return true;
    },
    showModal(Balanc){
      this.$refs.myModalRef.show(Balanc);
      this.RemainData = Balanc;
    },
    hideModal() {
      this.$refs.myModalRef.hide()
    },
    showCardModal(CardAmount){
      this.expandedRows = []
      this.$refs.myCardModalRef.show(CardAmount)
    },
    hideCardModal(ele) {
      this.$refs.myCardModalRef.hide();
      if(ele == 0) this.saveSvcClosure();
    },
    showConfModal(){
      this.$refs.myConfModalRef.show();
    },
    hideConfModal(ele) {
      this.$refs.myConfModalRef.hide();
      if(ele == 0){
        this.hideCM = 0;
        this.saveSvcClosure();
      }else{
        this.unmatchedAmt = parseInt(parseInt(Math.round((parseFloat(this.pendingCODAmt)+parseFloat(this.yesterdayCODAmt)-parseFloat(this.exceptionAmount))))-parseInt(Math.round(parseFloat(this.Deposit_Amount))));
      }
    },
    closeStatusRoleModal() {
      this.modalShow = false
      this.cardModalShow = false
      this.ReasonModalShow = false
      this.RecExcModalShow = false
      this.ExmodalShow = false
      this.commentModalShow = false
      this.ConfmodalShow = false
      this.ResetmodalShow = false
      this.errorModalShow = false
      this.awbStatusModalShow = false
    },

    GetShipmentUpdate() {

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'svcactualcodamt',
        'data': {
            hubid: this.localhubid,
            status: 'Delivered'
        },
        headers: {
            'Authorization': 'Bearer '+this.myStr
        }
      })
      .then(result => {
        this.penAmtLoading = true;
        if(result.data.rows.length > 0){
          this.yesterdayCODAmt = parseFloat(Math.round(0));
          this.GetPendingCODAmt();
        }else{

          axios({
            method: 'POST',
            url: apiUrl.api_url + 'external/getShipmentUpdate',
            data: {
                hubid: this.localhubid,
                status: 'Delivered'
            },
            headers: {
              'Authorization': 'Bearer '+this.myStr
            }
          }).then(result => {
            var data = []; let yDayCODAmt = 0;
            if(result.data.code==200){

              this.yesterdayCODAmt = (result.data.shipmentupdate) ? parseFloat(Math.round(result.data.shipmentupdate)) : 0;

              if(this.twokdenominationscount <=0){
                this.twokdenominationscount = parseInt(result.data.twokdenominationscount)
                //console.log(this.twokdenominationscount)
                this.twokfreeze = result.data.twokfreeze
                this.notesCountFreeze()
              }

            }
            this.GetPendingCODAmt();

          }, error => {
            this.penAmtLoading = false; console.error(error);
          })
        }
      }, error => {
          this.penAmtLoading = false;
          console.error(error);
      })
    },

    GetPendingCODAmt() {
      this.financeclosingamt = 0;
      this.financeoutstanding = 0;
      this.input = ({
          hubid: this.localhubid
      })

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'svcpendcodamt',
          'data': this.input,
          headers: {
              'Authorization': 'Bearer '+this.myStr
          }
      })
      .then(result => {
        if(result.data.rows.length > 0){
          this.pendingCODAmt = parseFloat(Math.round(result.data.rows[0].closingbalance));
          this.closingBalance = result.data.rows[0].closingbalance;
          this.financeclosingamt = result.data.rows[0].financeclosingamt;
          this.financeoutstanding = parseInt(result.data.rows[0].financeclosingamt);
          if(result.data.rows[0].totalamtdeposit > result.data.rows[0].p2pamt){
            this.p2pAmount = 0;
          }
        }else{
          this.pendingCODAmt = 0;
        }
        this.TolatCollection = parseFloat(Math.round((parseFloat(this.pendingCODAmt)+parseFloat(this.yesterdayCODAmt)-parseFloat(this.exceptionAmount))));
        this.penAmtLoading = false; this.disableButton = false;
      }, error => {
        this.penAmtLoading = false; console.error(error);
      })
    },

    GetBankData(index) {
      this.bankLoading[index] = true;
      this.disableButton = true;
      this.depositSlips[index].BankList = []; 
      this.depositSlips[index].BankMasterId = '';
      if(this.depositSlips[index].DepositType=='' || this.depositSlips[index].DepositType==null){
        return false;
      }

      let DepositType = '';
      if(this.depositSlips[index].DepositType==1){
        DepositType = 'SelfDeposit';
      }else if(this.depositSlips[index].DepositType==2){
        DepositType = 'CashPickup';
      }else{
        DepositType = 'IMPS';
      }

      this.input = ({
        DepositType: DepositType
      })

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'getdeposittypebank',
        data: this.input,
        headers: {
          'Authorization': 'Bearer '+this.myStr
        }
      }).then(async result => {
        if(result.data.result.code==200){
          this.bankLoading[index] = false;
          this.depositSlips[index].BankList = result.data.result.data.filter(item =>
            ! this.inActiveBankIDs.includes(item.BankMasterId)  // added inactive banks filter
          );

          await this.GetSVCExceptionData();
          await this.GetShipmentUpdate();
        }else {
          this.bankLoading[index] = false;
          this.depositSlips[index].BankList = [];
        }
      }, error => {
        this.bankLoading[index] = false;
        console.error(error)
      })
    },

    GetDenominationData(){
      this.denomLoading = true;
      axios({
          method: 'POST',
          url: apiUrl.api_url + 'getAllDenomination',
          headers: {
            'Authorization': 'Bearer '+this.myStr
          }
        })
        .then(result => {
          this.denomLoading = false;
          this.depositSlips.forEach(element => {
            element.denominationList = result.data.data
          });
          this.DenominationList = result.data.data;
        }, error => {
          this.denomLoading = false;
          console.error(error)
        })

    },

    GetSVCledgerData() {
        $('span[id^="vri"]').hide();
        $('span[id^="vrl"]').show();

        if(this.RSCOwner){
          this.input = ({
            offset: this.pageno,
            limit: 10,
            hubid: this.localhubid,
            fromdate: this.RSCOwner.EffectiveFromDate,
            todate: this.RSCOwner.EffectiveToDate
          })
        }else{
          this.input = ({
            offset: this.pageno,
            limit: 10,
            hubid: this.localhubid
          })
        }
        this.isLoading = true;
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'svcledgermaster',
            'data': this.input,
            headers: {
                'Authorization': 'Bearer '+this.myStr
            }
        })
        .then(result => {
          if(result.data.code == 200){
            this.listSVCledgerData = result.data.data;

            let totalRows     = result.data.count;
            this.resultCount  = result.data.count;
            this.resultdate  = result.data.date;
            if (totalRows < 10) {
                this.pagecount = 1
            } else {
                this.pagecount = Math.ceil(totalRows / 10)
            }
          }else{
            this.resultCount  = 0; this.listSVCledgerData = [];
          }
          this.isLoading = false;
        }, error => {
            this.isLoading = false; console.error(error);
        })
    },

    GetReasonList(){
      this.input = ({
        ReasonType:"SVC"
      })
      axios({
          method: 'POST',
          url: apiUrl.api_url + 'external/getCODReasons',
          data: this.input,
          headers: {
            'Authorization': 'Bearer '+this.myStr
          }
        })
        .then(result => {
          if(result.data.Reasons.code==200){
            if(this.localhubIsRSC == true){
              this.ReasonList = result.data.Reasons.data.filter(item => (item['ReasonsID'] != 186 && item['ReasonsID'] != 123 && item['ReasonsID'] != 65 &&
              item['ReasonsID'] != 82 && item['ReasonsID'] != 324 && item['ReasonsID'] != 325 && item['ReasonsID'] != 129 && item['ReasonsID'] != 130 && item['ReasonsID'] != 77));
            }else{
              this.ReasonList = result.data.Reasons.data.filter(item => (item['ReasonsID'] != 186 && item['ReasonsID'] != 123));
            }

            this.ReasonList=  result.data.Reasons.data.filter(item => (item['ReasonsID'] != 78 && item['ReasonsID'] != 65 && item['ReasonsID'] != 82));
            if(this.localhubIsRSC){
              const filterReasonList = this.ReasonList.filter(obj => obj['ReasonsID'] != 129 && obj['ReasonsID'] != 130 && obj['ReasonsID'] != 165 && 
              obj['ReasonsID'] != 325 && obj['ReasonsID'] != 363  && obj['ReasonsID'] != 324 && obj['ReasonsID'] != 77 );
              this.ReasonList = filterReasonList;
            }else{
              const filterReasonList = this.ReasonList.filter(obj => obj['ReasonsID'] != 402 && obj['ReasonsID'] != 188)
              this.ReasonList = filterReasonList;
            }
            console.log(this.localhubIsRSC , this.isFnF , this.srtpsr , this.nddiss , this.raziss,this.ReasonList)
          }else{
            console.log('Error', result.data.Reasons.message);
          }
        }, error => {
          console.error(error)
        })
    },

    //to get pagination
    getPaginationData(pageNum) {
        this.pageno = (pageNum - 1) * 10
        this.GetSVCledgerData()
    },

    //function is used for calculate notes amount
    notesCount(event, index, noteAmt){
      if(event.target.id){

        let Denomination = event.target.id;
        let NoteCount = event.target.value;

        console.log('Denomination', Denomination);
        console.log('NoteCount', NoteCount);
        console.log("mo"+event.target.id);

        document.getElementById("mo"+event.target.id).value = noteAmt * NoteCount;
        var arr = document.getElementsByName('note_amt' + index);
        this.depositSlips[index].tot_amt=0;

        for(var i=0;i<arr.length;i++){

          if(this.depositSlips[index].DenominationArr.indexOf(noteAmt) === -1) {
            this.depositSlips[index].DenominationArr.push(noteAmt);
          }

          if(parseInt(arr[i].value)){
            this.depositSlips[index].tot_amt += parseInt(arr[i].value);
          }
        }
        document.getElementById('tot_amt' + index).value = this.depositSlips[index].tot_amt;

        if(!this.isFnF) this.depositSlips[index].Deposit_Amount = this.depositSlips[index].tot_amt;
      }
    },
    notesCountFreeze(){
      if(this.twokfreeze){
        let Denomination = "2000-0";
        let NoteCount = this.twokdenominationscount;
        console.log("NoteCount ",NoteCount);
        document.getElementById(Denomination).value = NoteCount;
        //document.getElementById(Denomination).disabled = true;
        document.getElementById("mo"+Denomination).value = 2000 * NoteCount;
        var arr = document.getElementsByName('note_amt0');
        this.tot_amt=0;

        for(var i=0;i<arr.length;i++){

          if(this.DenominationArr.indexOf(Denomination) === -1) {
            this.DenominationArr.push(Denomination);
          }

          if(parseInt(arr[i].value)){
            this.tot_amt += parseInt(arr[i].value);
          }
        }
        document.getElementById('tot_amt0').value = this.tot_amt;

        if(!this.isFnF) this.Deposit_Amount = this.tot_amt;
      }
    },
    cardawbno(event){
      let awbArr = []; this.DisputeArr = []; this.CardAmount = 0; this.subLoading = this.disableButton = true;

      if(this.lowdis) {
        if(this.lowdisAmt > 1000){
          this.subLoading = this.disableButton = false;
          return false;
        }
      }

       if(this.fintech) {
        if(this.fintechAmt >= 10001){
          this.subLoading = this.disableButton = false;
          return false;
        }
      }

      if(this.srtptsvc) {
        if(this.srtptsvcfile.size>5242880){
          this.$alertify.error(" Failed! Upload Max File Size Should Not Be Greater Than 5 MB");
          this.srtptsvcfile = '';
          this.subLoading = this.disableButton = false;
          return false;
        }
  
        var name = '';

        if ( /\.(jpe?g|png|gif|bmp|xls|xlsx|csv|doc|docx|rtf|wks|wps|wpd|excel|xlr|pps|pdf|ods|odt)$/i.test(this.srtptsvcfile.name) ){
          name = this.srtptsvcfile.name;
        } else {
          this.$alertify.error(" Failed! Please Upload Only Valid Format: .png, .jpg, .jpeg, .gif, .bmp, .xls, .xlsx, .pdf, .ods, .csv, .doc, .odt, .docx, .rtf, .wks, .wps, .wpd, .excel, .xlr, .pps");
          this.srtptsvcfile = '';
          this.subLoading = this.disableButton = false;
          return false;
        }
      }
      
      this.srabscAWBNo = '';
      if(this.srabscarr[0]['awbNo']) {
        this.srabscarr.forEach(element => {
          if(element['awbNo']) {
            this.srabscAWBNo = this.srabscAWBNo ? this.srabscAWBNo+','+element['awbNo'] : element['awbNo'];
          }
        });
      }

      this.srtpsrAmt = 0;
      if(this.srtpsrarr[0]['srAmt']) {
        this.srtpsrarr.forEach(element => {
          if(element['srAmt']) {
            this.srtpsrAmt = parseFloat(this.srtpsrAmt) + parseFloat(element['srAmt']);
          }
        });
      }

      this.cassnatAWBNo = ''
      if(this.cassnatarr[0]['awbNo']) {
        this.cassnatarr.forEach((element, index) => { 
          if(element['awbNo']) {
            const numbers = element['awbNo'].split(',').map(num => num.trim());
            if(numbers.length > 50) {
              this.cassnatAWBNoError[index] = "Please enter up to 50 comma-separated AWB numbers.";   
              return;        
            } else {
              this.cassnatAWBNoError[index] = '';
              this.cassnatAWBNo = this.cassnatAWBNo ? this.cassnatAWBNo +','+ element['awbNo'] : element['awbNo'];
            }
          }
        })
      }

      // Check for errors in cassnatAWBNoError
      if (this.cassnatAWBNoError && Object.values(this.cassnatAWBNoError).some(error => error !== '')) {
        this.subLoading = this.disableButton = false;
        return false;
      }

      if(this.carissAWBNo) awbArr.push({ ReasonID:this.carissReason, AWBNo:this.checkAWB(this.carissAWBNo) });

      if(this.cassnatAWBNo) awbArr.push({ ReasonID:this.cassnatReason, AWBNo:this.checkAWB(this.cassnatAWBNo), SRDetails: this.cassnatarr });

      if(this.paychgAWBNo) awbArr.push({ ReasonID:this.paychgReason, AWBNo:this.checkAWB(this.paychgAWBNo) });

      if(this.vendrecAWBNo) awbArr.push({ ReasonID:this.vendrecReason, AWBNo:this.checkAWB(this.vendrecAWBNo) });

      if(this.casstolAWBNo) awbArr.push({ ReasonID:this.casstolReason, AWBNo:this.checkAWB(this.casstolAWBNo) });

      if(this.theftstolAWBNo) awbArr.push({ ReasonID:this.theftstolReason, AWBNo:this.checkAWB(this.theftstolAWBNo) });

      if(this.wrongdelAWBNo) awbArr.push({ ReasonID:this.wrongdelReason, AWBNo:this.checkAWB(this.wrongdelAWBNo) });

      if(this.srabscAWBNo) awbArr.push({ ReasonID:this.srabscReason, AWBNo:this.checkAWB(this.srabscAWBNo), SRDetails: this.srabscarr});

      if(this.srtpsrAmt) awbArr.push({ ReasonID:this.srtpsrReason, AWBNo:[], ReasonAmt:(this.srtpsrAmt)?this.srtpsrAmt:'0', SRDetails: this.srtpsrarr });

      if(this.srtptsvcAmt) awbArr.push({ ReasonID:this.srtptsvcReason, AWBNo:[], ReasonAmt:(this.srtptsvcAmt)?this.srtptsvcAmt:'0', ReasonURL: '' });

      if(this.lowdis) awbArr.push({ ReasonID:this.lowdisReason, AWBNo:[], ReasonAmt:(this.lowdisAmt)?this.lowdisAmt:'0' });

      if(this.amoimp) awbArr.push({ ReasonID:this.amoimpReason, AWBNo:[], ReasonAmt:(this.ReasonAmount)?this.ReasonAmount:'0' });

      if(this.nddissAWBNo) awbArr.push({ ReasonID:this.nddissReason, AWBNo:this.checkAWB(this.nddissAWBNo) });

      if(this.walissAWBNo) awbArr.push({ ReasonID:this.walissReason, AWBNo:this.checkAWB(this.walissAWBNo) });

      if(this.paypissAWBNo) awbArr.push({ ReasonID:this.paypissReason, AWBNo:this.checkAWB(this.paypissAWBNo) });

      if(this.razissAWBNo) awbArr.push({ ReasonID:this.razissReason, AWBNo:this.checkAWB(this.razissAWBNo) });
      
      if(this.pineAWBNo) awbArr.push({ ReasonID:this.pineReason, AWBNo:this.checkAWB(this.pineAWBNo) });

       if(this.fintech) awbArr.push({ ReasonID:this.fintechReason, AWBNo:[], ReasonAmt:(this.fintechAmt)?this.fintechAmt:'0' });

       if(this.codRot) awbArr.push({ ReasonID:this.codRotReason, AWBNo:[], ReasonAmt:(this.codRotAmt)?this.codRotAmt:'0' });

      if(this.habridpiAWBNo) awbArr.push({ ReasonID:this.habridpiReason, AWBNo:this.checkAWB(this.habridpiAWBNo), ReasonAmt:this.habridpiAMT });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getAWBNo',
        'data': ({'DisputeArr': awbArr,'hubid': this.localhubid}),
        headers: {
          'Authorization': 'Bearer '+this.myStr
        }
      })
      .then(async (awbres) => {
        this.subLoading = this.disableButton = false;

        if (awbres.data.code == 200) {
          if(awbres.data.invalidAwb.length>0){
            this.$alertify.error("Some of AWB numbers are invalid, please check: "+awbres.data.invalidAwb.join(', ')); return false;
          }else{
            this.CardAmount = awbres.data.total;
            this.DisputeArr = awbres.data.result;

            // Non-Delivery Dispute check for AWB no status
            if(this.nddissAWBNo || this.walissAWBNo || this.paypissAWBNo || this.razissAWBNo || this.pineAWBNo) {
              try {
                const payload = {
                   'nddissAWBNo': this.nddissAWBNo, 
                   'walissAWBNo': this.walissAWBNo, 
                   'paypissAWBNo': this.paypissAWBNo, 
                   'razissAWBNo': this.razissAWBNo,
                   'pineAWBNo': this.pineAWBNo 

                }
                const response = await axios.post(apiUrl.api_url + 'checkAWBNoStatus', {'awbnos' : payload },
                  { headers: { 'Authorization': 'Bearer ' + this.myStr } }
                );
            
                if (response.data.result && Object.keys(response.data.result).length !== 0) {                  
                    this.awbnoStatusTabel = response.data.result;
                    this.$refs.awbStatusModalRef.show();
                    return;
                }
              } catch (error) {
                console.error("Error checking AWB numbers:", error);
                this.$alertify.error("Failed to validate AWB numbers");
                return;
              }
            }

            // SR AWB no check
            if(this.cassnatAWBNo) {
              try {

                const cashShipSnatched = this.cassnatAWBNo ? this.cassnatarr : [];
                        
                const response = await axios.post(apiUrl.api_url + 'checkSRAWBNo', { 'srdetails' : cashShipSnatched},
                  { headers: { 'Authorization': 'Bearer ' + this.myStr } }
                );
            
                if(response.data.invalidAwb.length>0){
                  this.$alertify.error("Some of AWB numbers are not matched with selected SR, please check: "+response.data.invalidAwb.join(', ')); return false;
                }
              } catch (error) {
                console.error("Error checking AWB numbers:", error);
                this.$alertify.error("Failed to validate AWB numbers");
                return;
              }
            }


            this.showCardModal(this.CardAmount);
          }
        } else{
          this.$alertify.error("AWB numbers are invalid, please check."); return false;
        }
      })
      .catch((httpException) => {
        this.subLoading = this.disableButton = false;
        this.$alertify.error('Error occured'); return false;
      });
    },

    calculateSums (data) {
      const resultSums = {};
  
      data.forEach(item => {
        // Sum the values in the awb array for each result item
        const awbSum = item.awb.reduce((sum, awbObj) => {
          const value = parseFloat(Object.values(awbObj)[0]); // Get the first (and only) value in each awb object and convert it to a number
          return sum + value;
        }, 0);
        
        // Assign the sum to the ReasonID key in the resultSums object
        resultSums[item.ReasonID] = awbSum.toFixed(2);
      });
    
      return resultSums;
    },

    getReasonName(key) {
      if(key == 'nddissAWBNo') {
         return 'Non-Delivery Dispute';
      } else if(key == 'walissAWBNo') {
         return 'Wallet issue';
      } else if(key == 'paypissAWBNo') {
        return 'Payphi issue';
      } else if(key == 'razissAWBNo') {
        return 'Razor Pay Issue';
      }else if(key == 'pineAWBNo') {
        return 'Pinelab Issue';
      }
    },

    checkAWB(awbno){

      if(awbno){
        if(/\s/g.test(awbno) == true || awbno.indexOf(',') > -1){
          awbno =awbno.replace(/,\s*$/, "").replace(/ /g,'').split(',');
        }
        if(Array.isArray(awbno) == false){
          awbno = new Array(awbno);
        }

        return awbno;
      }
    },

    async saveSvcClosure() {

      let DepositAmount = parseInt(this.Deposit_Amount);
      let DepositReasonExcepAmount = ''; this.unmatchedAmt = 0;
      DepositReasonExcepAmount = parseFloat(Math.round(DepositAmount));

      if(this.RSCOwner && this.isFnF){

        if(this.hideCM==1){
          this.showConfModal(); return false;
        }

        this.disableButton = true; this.subLoading = true;
        if(this.depositSlips.length > 0) {
            this.input = ({
                DepositDate:      this.depositSlips[this.depositSlips.length-1]['DepositDate'],
                BankDeposit:      DepositReasonExcepAmount,
                CreatedBy:        this.localuserid,
                HubId:            this.localhubid,
                BatchID:          this.depositSlips[this.depositSlips.length-1]['BatchID'] ? this.depositSlips[this.depositSlips.length-1]['BatchID'] : this.BatchID,
                EffectiveToDate:  this.RSCOwner.EffectiveToDate
            })

            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'RSCFnFClosure',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer '+this.myStr
                }
            })
            .then((response) => {
              this.hideCM = 1;

              if (response.data.errorCode == 0) {
                this.$alertify.success(response.data.msg);
                this.disableButton = false; this.subLoading = false;
                window.scrollBy(0, 1000); this.resetForm();
              } else if (response.data.errorCode == -1) {
                this.$alertify.error(response.data.msg)
              }
            }).catch((httpException) => {
              this.hideCM = 1; this.disableButton = false; this.subLoading = false;
              this.$alertify.error('Error occured')
            });
          }
      }else{

        if(this.CardAmount > 0){ //65
          //DepositReasonExcepAmount = parseFloat(Math.round(DepositAmount+parseFloat((this.ReasonAmount)?this.ReasonAmount:'0')+parseFloat(this.CardAmount)));
          DepositReasonExcepAmount = parseFloat(Math.round(DepositAmount+parseFloat(this.CardAmount)));
        }

        //let TolatCollection = parseFloat(Math.round((parseFloat(this.pendingCODAmt)+parseFloat(this.yesterdayCODAmt)-parseFloat(this.exceptionAmount)-parseFloat(this.CardAmount))));
        let TolatCollection = parseFloat(Math.round((parseFloat(this.pendingCODAmt)+parseFloat(this.yesterdayCODAmt)-parseFloat(this.exceptionAmount))));

        let p2pamt = parseInt(this.p2pAmount);
        if(DepositAmount !== parseInt(this.tot_amt)){
          this.$alertify.error("Denomination details & Deposit amount should be same, please check.");

          // let error = document.getElementById("d_a");
          //  error.innerHTML      = "Denomination details & Deposit amount should be same, please check.";
          //  error.style.display  = "block";
           return false;
        }else{
          if(p2pamt > 0){
            DepositAmount = DepositAmount - p2pamt;
          }

          //document.getElementById("d_a").style.display = "none";

          this.unmatchedAmt = parseFloat(Math.round(parseFloat(TolatCollection)-parseFloat(DepositReasonExcepAmount)));

          let ClosingBalance = 0;

          if(this.unmatchedAmt > 0 && this.unmatchedAmt <= 5){
            this.unmatchedAmt = 0;
          }else{
            if((DepositReasonExcepAmount < TolatCollection) && (this.unmatchedAmt>0)){
                this.showModal(this.unmatchedAmt);
                return false;
            }else if((this.CardAmount > 0) && (DepositReasonExcepAmount > TolatCollection)){
              if(parseInt(DepositReasonExcepAmount - TolatCollection) > 5){
                this.unmatchedAmt = parseFloat(Math.round(parseFloat(TolatCollection)-parseFloat(this.Deposit_Amount)));
                this.$alertify.error("Deposit amount including sum of dispute amount should not be greater than total outstanding COD amount and extra amount should not more than 5 Rs.");
                return false;
              }
            }
          }


          if(this.hideCM==1){
            this.showConfModal(); return false;
          }
          if(this.lowdis || this.unmatchedAmt<=0 || this.fintech || this.codRot){
            this.disableButton = true; this.subLoading = true;
            // Save attchemnet
            if(this.srtptsvc) {
              const fd = new FormData();
              fd.append('file', this.srtptsvcfile, this.srtptsvcfile.name);
              fd.append('s3bucketKey', 'SVC-'+this.BatchID);
              fd.append('reason', 'SVCDeposit');
              await axios.post(apiUrl.api_url + 'uploadsvcfile', fd,
              {
                headers: {
                  'Authorization': 'Bearer ' + this.myStr
                }
              })
              .then(async res => {
                await this.DisputeArr.forEach(element => {
                  if(element.ReasonID == 363 || element.ReasonID == 165) {
                    element.ReasonURL = this.fullyDecode(res.data.data);
                  }
                });            
              }).catch((httpException) => {
                this.hideCM = 1; this.disableButton = false; this.subLoading = false;
                this.$alertify.error('File upload Error occured')
              });
            }

            let CODAmount = 0;
            let OpeningBalance = 0;

            function delay(ms) {
              return new Promise(resolve => setTimeout(resolve, ms));
            }
            this.isLoading=true;
            for(let index = 0 ; index < this.depositSlips.length; index++) {

                let NoteCountArr = []; let DenominationIDArr = [];
                if(this.depositSlips[index]['DenominationArr'].length > 0){
                  this.depositSlips[index]['DenominationArr'].forEach(function (denomi) {
                    NoteCountArr.push(parseInt(document.getElementById("mo"+denomi+'-'+index).value) / parseInt(denomi));
                    DenominationIDArr.push(parseInt(document.getElementById("moi"+denomi+'-'+index).value));
                  });                      
                }

                ClosingBalance = parseFloat(Math.round(parseFloat(TolatCollection)-parseFloat(this.depositSlips[index]['Deposit_Amount'])));      
                CODAmount = parseFloat(Math.round(parseFloat(this.yesterdayCODAmt)+parseFloat(p2pamt)));
                OpeningBalance = parseFloat(TolatCollection);

                this.finalArray = {
                  DepositDate: this.depositSlips[index]['DepositDate'],
                  DeliveryDate: this.depositSlips[index]['DeliveryDate'],
                  Deposit_Amount: this.depositSlips[index]['Deposit_Amount'],
                  DepositType: this.depositSlips[index]['DepositType'],
                  BankID: this.depositSlips[index]['BankMasterId'],
                  BankDeposit: this.depositSlips[index]['Deposit_Amount'],
                  TransactionID: this.depositSlips[index]['TransactionID'],
                  ReasonID: index == (this.depositSlips.length-1) ? ((this.amoimpReason)?this.amoimpReason:null ) : null,
                  ReasonAmount: 0,
                  AWBNo: index == (this.depositSlips.length-1) ? (this.DisputeArr ? this.DisputeArr : new Array()) : new Array(),
                  CardAmount:  index == (this.depositSlips.length-1) ? ClosingBalance : 0,
                  CreatedBy: this.localuserid,
                  HubId: this.localhubid,
                  HubZoneId: this.localhubzoneid,
                  DifferenceAmount: 0,
                  TolatCollection: TolatCollection,
                  StatusID: 1,
                  OpeningBalance: OpeningBalance,
                  ClosingBalance: (ClosingBalance)?ClosingBalance:0,
                  FinanceConfirmAmount: 0,
                  CODAmount: index == 0 ? CODAmount : 0,
                  IsActive: true,
                  BatchID: this.depositSlips[index]['BatchID'] ? this.depositSlips[index]['BatchID'] : this.BatchID,
                  p2pamt: p2pamt,
                  totalAmtdeposit: this.depositSlips[index]['Deposit_Amount'] + p2pamt,
                  Denomination: this.DenominationArr,
                  NoteCount: NoteCountArr,
                  DenominationID: DenominationIDArr,
                  exceptionId: this.exceptionArr,
                  exceptionAmount: this.exceptionAmount,
                  hubIsRSC: this.localhubIsRSC,
                  financeclosingamt: parseInt(this.financeclosingamt),
                  twokdenominationscount:this.twokdenominationscount
              }

              TolatCollection = ClosingBalance

              try {
                await axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'submitSVCClosure',
                    'data': this.finalArray,
                    headers: {
                        'Authorization': 'Bearer '+this.myStr
                    }
                })
                .then((response) => {
                  this.hideCM = 1;
                  if (response.data.errorCode == 0) {
                    this.$alertify.success(response.data.msg);
                    this.disableButton = false; this.subLoading = false;
                    window.scrollBy(0, 1000); 
                  } else if (response.data.errorCode == -1) {
                    this.$alertify.error(response.data.msg)
                  }
                })
                .catch((httpException) => {
                  this.hideCM = 1; this.disableButton = false; this.subLoading = false;
                  this.$alertify.error(' Save Error occured')
                });
              } catch(err) {
                this.hideCM = 1; this.disableButton = false; this.subLoading = false;
                this.$alertify.error('Save Error occured')
              }

            console.log(' this.finalArray',  this.finalArray)
              await delay(2000)
          }
          this.isLoading=false;
          this.resetForm();
        
          } else {
            this.hideCM = 1; this.$alertify.error('Error occured')
          }
        }
      }
    },


    fullyDecode(url) {
      let decodedUrl = url;
      let prevUrl;
      do {
        prevUrl = decodedUrl;
        decodedUrl = decodeURIComponent(decodedUrl);
      } while (prevUrl !== decodedUrl);
      return decodedUrl;
    },

    //function is used for upload files on AWS s3bucket
    onUpload(index, event){
      this.disableButton = true;

      if(event.target.files.length<=0){
        this.disableButton = false; return false;
      }

      this.selectedFile = event.target.files[0];

      var name = this.selectedFile.name;
      if(this.selectedFile.size>5242880){
        this.$alertify.error(event.srcElement.placeholder + " Failed! Upload Max File Size Should Not Be Greater Than 5 MB");
        this.disableButton = false; this.DepositSlip = ''; return false;
      }

      if ( /\.(jpe?g|png|gif|bmp|xls|xlsx|csv|doc|docx|rtf|wks|wps|wpd|excel|xlr|pps|pdf|ods|odt)$/i.test(this.selectedFile.name) ){
        name = this.selectedFile.name;
      }else{
        this.$alertify.error(event.srcElement.placeholder + " Failed! Please Upload Only Valid Format: .png, .jpg, .jpeg, .gif, .bmp, .xls, .xlsx, .pdf, .ods, .csv, .doc, .odt, .docx, .rtf, .wks, .wps, .wpd, .excel, .xlr, .pps");
        this.disableButton = false;
        this.DepositSlip = this.selectedFile = '';
        return false;
      }

      var BatchID = this.localhubid+''+Math.floor(Math.random() * (Math.pow(10,5)));
      this.depositSlips[index].BatchID = BatchID;

      console.log(' this.depositSlips[index].BatchID',  this.depositSlips[index].BatchID)

      const fd = new FormData();
      fd.append('file', this.selectedFile, name);
      fd.append('s3bucketKey', 'SVC-'+this.depositSlips[index].BatchID);

      if(event.target.id=="ReasonSlip"){
        fd.append('reason', 'Reason');
        this.ReasonLoading = true;
      }else{
        this.DepositLoading = true;
      }

      axios.post(apiUrl.api_url + 'uploadsvcfile', fd,
      {
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      })
      .then(res => {
        if(event.target.id=="ReasonSlip"){
          this.getS3bucketFiles('Reason', this.depositSlips[index].BatchID, index);
        }else{
          this.getS3bucketFiles(null,this.depositSlips[index].BatchID, index);
        }
      }, error => {
        this.ReasonLoading = false; this.DepositLoading = false; this.disableButton = false;
        console.error(error)
      });
    },

    getS3bucketFiles(Reason=null, BatchID, index){

      this.input = ({
        BatchID : BatchID,
        Reason : Reason,
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getfilelist',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      })
      .then(result => {
        this.disableButton = false;
        if(Reason){
          this.ReasonLoading = false;
          this.reasonFileList = result.data.data;

          let error = document.getElementById("rss");
          error.innerHTML      = "";
          error.style.display  = "none";
        }else{
          this.DepositLoading = false;
          console.log('uploadFileList', result.data.data)
          this.depositSlips[index].uploadFileList = result.data.data;

          let error = document.getElementById("dps" + index);
          error.innerHTML      = "";
          error.style.display  = "none";
        }
      }, error => {
        this.disableButton = false; this.ReasonLoading = false; this.DepositLoading = false;
        console.error(error)
      })
    },

    GetSVCExceptionData() {
      if( !this.localhubname ){
        this.$alertify.error("Hub Name does not exist.");
        return false;
      }
      this.exceptionLoading = true;

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getSVCException',
          'data': {
            hubname: this.localhubname,
            hubid: this.localhubid
          },
          headers: {
              'Authorization': 'Bearer '+this.myStr
          }
      })
      .then(result => {
        if (result.data.code == 200) {
          this.exceptionLoading = false;
          this.exceptionList = result.data.data;
          this.exception = result.data.data;

          var obj = 0; this.exceptionArr = [];
          for(var i=0; i < this.exceptionList.length; i++) {
             obj += parseFloat(this.exceptionList[i].NetPayment);
             this.exceptionArr.push(this.exception[i].ShippingID);
          }
          this.exceptionAmount = parseFloat(Math.round(obj));
        }else {
          this.exceptionAmount = 0;
          this.exceptionLoading = false;
        }
      }, error => {
          this.exceptionLoading = false;
          console.error(error);
      })
    },

    addExceptionData(event) {
      var obj = 0; this.exceptionArr = [];
      for(var i=0; i < this.exception.length; i++) {
         obj += parseFloat(this.exception[i].NetPayment);
         this.exceptionArr.push(this.exception[i].ShippingID);
      }
      this.exceptionAmount = parseFloat(Math.round(obj));
      this.TolatCollection = parseFloat(Math.round((parseFloat(this.pendingCODAmt)+parseFloat(this.yesterdayCODAmt)-parseFloat(this.exceptionAmount))));
    },

    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {

        this.DisputeArr = []; this.CardAmount = 0;

         if(this.amoimp && this.reasonFileList.length<=0){
           let error = document.getElementById("rss"); error.innerHTML = "Reason slip used for tax payment/ imprest is required Or please check file extension.";
           error.style.display  = "block"; return false;
         }

         let tranIdArr = []
         this.tot_amt = 0
         this.Deposit_Amount = 0
         this.showError = false;
         var fileError = false
         for (const [index, element] of this.depositSlips.entries()) { 
            if(element['uploadFileList'].length<=0){
              let error = document.getElementById("dps" + index); error.innerHTML = "Deposit slip is required Or please check file extension.";
              error.style.display  = "block";
              fileError = true
            }
            this.tot_amt += element.tot_amt;
            this.Deposit_Amount += element.Deposit_Amount;

            if(!this.isFnF) document.getElementById("d_a"+ index).style.display = "none";
            // Vaildate deposit amount
            if(((element.tot_amt != 0 && element.tot_amt != parseInt(element.Deposit_Amount))||!element.tot_amt) && !this.isFnF){      
              let error = document.getElementById("d_a" + index);
              error.innerHTML = "Total denomination & deposit amount should be same, please check.";
              error.style.display = "block";
              this.showError = true;
            }

            // Duplicate transaction Id check
            if(element['TransactionID'].length > 0) {
              let ids = element['TransactionID'].split(',');
              if(ids.length > 0 && tranIdArr.length > 0) {
                for (const ele of ids) {  
                  if(tranIdArr.includes(ele)) {
                    this.$alertify.error("Duplicate transaction id, please check")
                    return false;
                  }
                }
              }
              tranIdArr.push(element['TransactionID']); 
            }         
         };

        
         if(result && !fileError){

           if((((this.tot_amt != 0 && this.tot_amt != parseInt(this.Deposit_Amount))||!this.tot_amt) && !this.isFnF) || this.showError){            
              this.$alertify.error("Denomination details & Deposit amount should be same, please check.");     
              // let error = document.getElementById("d_a");
              // error.innerHTML = "Total denomination & deposit amount should be same, please check.";
              // error.style.display = "block";
              return false;
          }else{
            this.unmatchedAmt = parseInt(parseInt(Math.round((parseFloat(this.pendingCODAmt)+parseFloat(this.yesterdayCODAmt)-parseFloat(this.exceptionAmount))))-parseInt(Math.round(parseFloat(this.Deposit_Amount))));

            //78,152,186
            if(parseInt(Math.round(parseFloat(this.Deposit_Amount))) > parseInt(Math.round((parseFloat(this.pendingCODAmt)+parseFloat(this.yesterdayCODAmt)-parseFloat(this.exceptionAmount))))){
              this.unmatchedAmt = 0;
              this.showExModal(parseInt(parseInt(Math.round(parseFloat(this.Deposit_Amount))) - parseInt(Math.round(parseFloat(this.pendingCODAmt)+parseFloat(this.yesterdayCODAmt)-parseFloat(this.exceptionAmount)))));
            }else{
              if(this.amoimp || this.cariss || this.paychg || this.cassnat || this.casstol || this.theftstol || this.vendrec || this.wrongdel || this.srabsc || this.srtpsr || this.srtptsvc || this.lowdis || this.fintech || this.codRot || this.nddissReason || this.walissReason || this.razissReason || this.paypissReason || this.habridpiReason || this.pineReason){
                this.cardawbno(event);
              }else{
                this.saveSvcClosure();
              }
            }
          }
        }else{
          console.log('validation errors exist')
          this.$alertify.error("There are some errors. Please verify them.");     
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
        this.$alertify.error("There are some errors. Please verify them.");
      });
    },

    resetForm() {
      this.twokdenominationscount=0;
      this.twokfreeze = false;
      this.DepositLoading = false; this.ReasonLoading = false; this.disableButton = false; this.subLoading = false;
      this.pageno = this.tot_amt = this.unmatchedAmt = this.CardAmount = 0;
      this.uploadFileList = []; this.reasonFileList = []; this.BankList = []; this.exception = []; this.exceptionList = []; this.exceptionArr = [];
      this.DepositDate = this.Deposit_Amount = this.DepositType = this.BankMasterId = this.TransactionID = this.DepositSlip = this.ReasonSlip = this.Reason = '';
      this.DisputeArr = []; this.RSCOwner = '';
      this.nonIsHybrid = []; this.invalidShipments = []; this.invalidShipmentsMsg = '';
      this.amoimp = this.vendrec = this.cassnat = this.cariss = this.paychg = this.casstol = this.theftstol = this.wrongdel = this.srabsc = this.srtpsr = this.srtptsvc = this.lowdis = this.fintech = this.codRot = this.nddiss = this.waliss = this.raziss = this.paypiss = this.habridpi = this.pine= false;
      this.ReasonAmount = this.vendrecAWBNo = this.cassnatAWBNo = this.carissAWBNo = this.paychgAWBNo = this.casstolAWBNo = this.theftstolAWBNo = this.wrongdelAWBNo = this.srabscAWBNo = this.srtpsrAmt = this.srtptsvcAmt = this.nddissAWBNo = this.walissAWBNo = this.razissAWBNo = this.paypissAWBNo = this.habridpiAWBNo = this.habridpiAMT = this.pineAWBNo = '';
      this.amoimpReason = this.vendrecReason = this.cassnatReason = this.carissReason = this.paychgReason = this.casstolReason = this.theftstolReason = this.wrongdelReason = this.srabscReason = this.srtpsrReason = this.srtptsvcReason = this.lowdisReason = this.fintechReason = this.codRotReason = this.nddissReason = this.walissReason = this.razissReason = this.paypissReason = this.habridpiReason =  this.pineReason = '';
      $('#denomlist input[type="text"]').val(0); $('#denomlist input[type="number"]').val('');
      // document.getElementById("d_a").style.display = "none";
      this.depositSlips = []; this.addNewDepositSlip();
      this.GetSVCExceptionData();
      this.GetShipmentUpdate();
      this.GetSVCledgerData();
      this.$validator.reset(); this.errors.clear(); document.getElementById('svcform').reset();
      this.srabscarr = [
        {         
          awbNo: '',
          srId: '',
          srName: ''
        }
      ];
      this.srtpsrarr = [
        {         
          srAmt: '',
          srId: '',
          srName: ''
        }
      ];
      this.cassnatarr = [
        {         
          awbNo: '',
          srId: '',
          srName: ''
        }
      ];
    },

    showHideImages(index, elem){
      if(elem=='vrrl'){
        $('#vrl'+index).show();
        $('#vri'+index).hide();

        $('#vrri'+index).show();
        $('#vrrl'+index).hide();
      }else{
        $('#vrri'+index).hide();
        $('#vrrl'+index).show();

        $('#vri'+index).show();
        $('#vrl'+index).hide();
      }
    },

    changeDepType(){ //change deposit Amount
     this.unmatchedAmt = this.CardAmount = 0; this.Reason = ''; this.ReasonAmount = ''; this.DisputeArr = []; this.reasonFileList = [];
     this.amoimp = this.vendrec = this.lowdis = this.fintech = this.codRot =this.cassnat = this.cariss = this.paychg = this.casstol = this.theftstol = this.wrongdel = this.srabsc = this.srtpsr = this.srtptsvc = this.nddiss = this.waliss = this.raziss = this.paypiss = this.pine = false;
     this.ReasonAmount = this.vendrecAWBNo = this.cassnatAWBNo = this.carissAWBNo = this.paychgAWBNo = this.casstolAWBNo = this.theftstolAWBNo = this.wrongdelAWBNo = this.srabscAWBNo = this.srtpsrAmt = this.srtptsvcAmt = this.nddissAWBNo = this.walissAWBNo = this.razissAWBNo = this.paypissAWBNo = this.habridpiAWBNo = this.habridpiAMT = this.pineAWBNo = '';

      $('input[name="reason"]').each(function() {
  			this.checked = false;
  		});
    },

    showCheckboxes(){
      var checkboxes = document.getElementById("checkboxes");
      if (!this.expanded) {
        checkboxes.style.display = "block";
        this.expanded = true;
      } else {
        checkboxes.style.display = "none";
        this.expanded = false;
      }
    },

    setid(key){
      return key;
    },

    showHideReasonField(Reason){
      console.log('call' , Reason , process.env.NODE_ENV == 'development' , Reason == 325 ,(process.env.NODE_ENV == 'development' && Reason == 325)  , process.env.NODE_ENV)
      if(($('#'+Reason).prop("checked") == true) && Reason){
        if(Reason == 65){
          this.amoimp = true; this.amoimpReason = Reason;
        }else if((process.env.NODE_ENV == 'development' && Reason == 119) || (process.env.NODE_ENV == 'production' && Reason == 98)){
          this.vendrec = true; this.vendrecReason = Reason;
        }else if((process.env.NODE_ENV == 'development' && Reason == 77) || (process.env.NODE_ENV == 'production' && Reason == 77)){
          this.cassnat = true; this.cassnatReason = Reason;
          this.cassnatarr = []; this.addCassnatSR();
          if(this.pendingClosureList.length <= 0) this.getSRList();
        }else if((process.env.NODE_ENV == 'development' && Reason == 78) || (process.env.NODE_ENV == 'production' && Reason == 78)){
          this.cariss = true; this.carissReason = Reason;
        }else if((process.env.NODE_ENV == 'development' && Reason == 186) || (process.env.NODE_ENV == 'production' && Reason == 123)){
          this.paychg = true; this.paychgReason = Reason;
        }else if((process.env.NODE_ENV == 'development' && Reason == 69) || (process.env.NODE_ENV == 'production' && Reason == 69)){
          this.casstol = true; this.casstolReason = Reason;
        }else if((process.env.NODE_ENV == 'development' && Reason == 82) || (process.env.NODE_ENV == 'production' && Reason == 82)){
          this.theftstol = true; this.theftstolReason = Reason;
        }else if((process.env.NODE_ENV == 'development' && Reason == 284) || (process.env.NODE_ENV == 'production' && Reason == 127)){
          this.wrongdel = true; this.wrongdelReason = Reason;
        }else if((process.env.NODE_ENV == 'development' && Reason == 80) || (process.env.NODE_ENV == 'production' && Reason == 80)){
          this.lowdis = true; this.lowdisReason = Reason; this.lowdisAmt = '';
        }else if((process.env.NODE_ENV == 'development' && Reason == 324) || (process.env.NODE_ENV == 'production' && Reason == 129)){
          this.srabsc = true; this.srabscReason = Reason;
          this.srabscarr = []; this.addNewSR();
          if(this.pendingClosureList.length <= 0) this.getSRList();
        }else if((process.env.NODE_ENV == 'development' && Reason == 325) || (process.env.NODE_ENV == 'production' && Reason == 130)){
          this.srtpsr = true; this.srtpsrReason = Reason;
          this.srtpsrarr = []; this.addSrtpNewSR();
          if(this.srtpsrPendingClosureList.length <= 0) this.getSRList();
        }else if((process.env.NODE_ENV == 'development' && Reason == 363) || (process.env.NODE_ENV == 'production' && Reason == 165)){
          this.srtptsvc = true; this.srtptsvcReason = Reason;
        }else if((process.env.NODE_ENV == 'development' && Reason == 152) || (process.env.NODE_ENV == 'production' && Reason == 121)){
          this.nddiss = true; this.nddissReason = Reason;
        }else if((process.env.NODE_ENV == 'development' && Reason == 327) || (process.env.NODE_ENV == 'production' && Reason == 134)){
          this.waliss = true; this.walissReason = Reason;
        }else if((process.env.NODE_ENV == 'development' && Reason == 328) || (process.env.NODE_ENV == 'production' && Reason == 135)){
          this.paypiss = true; this.paypissReason = Reason;
        }else if((process.env.NODE_ENV == 'development' && Reason == 365) || (process.env.NODE_ENV == 'production' && Reason == 167)){
          this.raziss = true; this.razissReason = Reason;
        }else if((process.env.NODE_ENV == 'development' && Reason == 394) || (process.env.NODE_ENV == 'production' && Reason == 185)){
          this.pine = true; this.pineReason = Reason;
        }
        else if((process.env.NODE_ENV == 'development' && Reason == 369) || (process.env.NODE_ENV == 'production' && Reason == 171)){
          this.habridpi = true; this.habridpiReason = Reason;
        }
        else if((process.env.NODE_ENV == 'development' && Reason == 400) || (process.env.NODE_ENV == 'production' && Reason == 187)){
          this.fintech = true; this.fintechReason = Reason; this.fintechAmt = '';
        }
        else if((process.env.NODE_ENV == 'development' && Reason == 402) || (process.env.NODE_ENV == 'production' && Reason == 188)){
          this.codRot = true; this.codRotReason = Reason; this.codRotAmt = '';
        }
      }else{
        if(Reason == 65){
          this.amoimp = false; this.ReasonAmount = ''; this.reasonFileList = []; this.amoimpReason = '';
        }else if((process.env.NODE_ENV == 'development' && Reason == 119) || (process.env.NODE_ENV == 'production' && Reason == 98)){
          this.vendrec = false; this.vendrecAWBNo = ''; this.vendrecReason = '';
        }else if((process.env.NODE_ENV == 'development' && Reason == 77) || (process.env.NODE_ENV == 'production' && Reason == 77)){
          this.cassnat = false; this.cassnatAWBNo = ''; this.cassnatReason = '';
          this.cassnatarr = []; this.addCassnatSR();
        }else if((process.env.NODE_ENV == 'development' && Reason == 78) || (process.env.NODE_ENV == 'production' && Reason == 78)){
          this.cariss = false; this.carissAWBNo = ''; this.carissReason = '';         
        }else if((process.env.NODE_ENV == 'development' && Reason == 186) || (process.env.NODE_ENV == 'production' && Reason == 123)){
          this.paychg = false; this.paychgAWBNo = ''; this.paychgReason = '';
        }else if((process.env.NODE_ENV == 'development' && Reason == 69) || (process.env.NODE_ENV == 'production' && Reason == 69)){
          this.casstol = false; this.casstolAWBNo = ''; this.casstolReason = '';
        }else if((process.env.NODE_ENV == 'development' && Reason == 82) || (process.env.NODE_ENV == 'production' && Reason == 82)){
          this.theftstol = false; this.theftstolAWBNo = ''; this.theftstolReason = '';
        }else if((process.env.NODE_ENV == 'development' && Reason == 284) || (process.env.NODE_ENV == 'production' && Reason == 127)){
          this.wrongdel = false; this.wrongdelAWBNo = ''; this.wrongdelReason = '';
        }else if((process.env.NODE_ENV == 'development' && Reason == 80) || (process.env.NODE_ENV == 'production' && Reason == 80)){
          this.lowdis = false; this.lowdisReason = '';this.lowdisAmt = '';
        }else if((process.env.NODE_ENV == 'development' && Reason == 324) || (process.env.NODE_ENV == 'production' && Reason == 129)){
          this.srabscarr = []; this.addNewSR();
          this.srabsc = false; this.srabscAWBNo = ''; this.srabscReason = '';
        }else if((process.env.NODE_ENV == 'development' && Reason == 325) || (process.env.NODE_ENV == 'production' && Reason == 130)){
          this.srtpsrarr = []; this.addSrtpNewSR();
          this.srtpsr = false; this.srtpsrAmt = ''; this.srtpsrReason = '';
        }else if((process.env.NODE_ENV == 'development' && Reason == 363) || (process.env.NODE_ENV == 'production' && Reason == 165)){
          this.srtptsvc = false; this.srtptsvcAmt = ''; this.srtptsvcReason = '';
        }else if((process.env.NODE_ENV == 'development' && Reason == 152) || (process.env.NODE_ENV == 'production' && Reason == 121)){
          this.nddiss = false; this.nddissAWBNo = ''; this.nddissReason = '';
        }else if((process.env.NODE_ENV == 'development' && Reason == 327) || (process.env.NODE_ENV == 'production' && Reason == 134)){
          this.waliss = false; this.walissAWBNo = ''; this.walissReason = '';
        }else if((process.env.NODE_ENV == 'development' && Reason == 328) || (process.env.NODE_ENV == 'production' && Reason == 135)){
          this.paypiss = false; this.paypissAWBNo = ''; this.paypissReason = '';
        }else if((process.env.NODE_ENV == 'development' && Reason == 365) || (process.env.NODE_ENV == 'production' && Reason == 167)){
          this.raziss = false; this.razissAWBNo = ''; this.razissReason = '';
        }else if((process.env.NODE_ENV == 'development' && Reason == 394) || (process.env.NODE_ENV == 'production' && Reason == 185)){
          this.pine = false; this.pineAWBNo = ''; this.pineReason = '';
        }
        else if((process.env.NODE_ENV == 'development' && Reason == 369) || (process.env.NODE_ENV == 'production' && Reason == 171)){
          this.habridpi = false; this.habridpiAWBNo = ''; this.habridpiAMT = ''; this.habridpiReason = '';
        }
        else if((process.env.NODE_ENV == 'development' && Reason == 400) || (process.env.NODE_ENV == 'production' && Reason == 187)){
          this.fintech = false; this.fintechReason = '';this.fintechAmt = '';
        }
        else if((process.env.NODE_ENV == 'development' && Reason == 402) || (process.env.NODE_ENV == 'production' && Reason == 188)){
          this.codRot = false; this.codRotReason = '';this.codRotAmt = '';
        }
      }
    },

    showReasonAWBNo(ele){
      this.DisputeArr = [];
      this.DisputeArr = ele;
      this.expandedRows = []
      this.$refs.myReasonModalRef.show();
    },

    showRecExcAWBNo(eletyp, ele, eleawb){

      this.DisputeArr = [];

      if(ele>0){
        let AWBArr = {}; AWBArr['awb'] = []

        AWBArr['Reason'] = "Exception"

        eleawb = eleawb.split(',');
        if(eleawb.length>0){
          eleawb.forEach(async(item, i) => {
            let obj = {};
            obj[item]=item;
            AWBArr['awb'].push(obj)
          });
        }else{
          let obj = {};
          obj[eleawb]=eleawb;
          AWBArr['awb'].push(obj)
        }
        AWBArr['amount'] = ele

        this.DisputeArr = new Array(AWBArr);
      }

      this.$refs.myRecExcModalRef.show();
    },

    showExModal(Balanc){
       this.$refs.myExModalRef.show(Balanc)
       this.ExData = Balanc;
    },

    hideExModal(ele) {
      if(ele == 0){
        this.$refs.myExModalRef.hide()
        this.saveSvcClosure();
      }else{
        this.$refs.myExModalRef.hide()
      }
    },

    showComment(ele, type){
      this.comment = []; this.cType = ''; this.comment = ele;
      if(type=='c') this.cType = 'Finance Comment'; else this.cType = 'Transaction Id';
      this.$refs.myCommentModalRef.show();
    },

    // showResetModal(data){
    //   this.resetdata = []; this.resetdata = data; this.resetDD = ''; this.resetDD = data.deliverydate; this.resetType = 'reset SVC closure';
    //   this.$refs.myResetModalRef.show();
    // },

    // hideResetModal(ele) {
    //   this.$refs.myResetModalRef.hide();
    //   if(ele == 0){
    //     this.resetSVCledger(this.resetdata);
    //   }
    // },

    // resetSVCledger(data){
    //   this.isLoading = true;
    //   this.input = ({
    //     svcledgerid:      data.svcledgerid,
    //     hubid:            this.localhubid,
    //     openingbalance:   data.openingbalance,
    //     codamount:        data.codamount,
    //     bankdeposit:      data.bankdeposit,
    //     statusid:         data.statusid,
    //     financereasonid:  data.financereasonid,
    //     createdby:        data.createdby,
    //     username:         this.localuserid,
    //     deliverydate:     this.resetDD
    //   });

    //   axios({
    //     method: 'POST',
    //     'url': apiUrl.api_url + 'deleteSVCLedgerEntry',
    //     'data': this.input,
    //     headers: {
    //       'Authorization': 'Bearer '+this.myStr
    //     }
    //   })
    //   .then(async response => {
    //     this.isLoading = false;
    //     if (response.data.code == 200) {


    //       var userdetailEncrypt = window.localStorage.getItem('accessuserdata')
    //       var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    //       var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    //       var userdetail = JSON.parse(plaintext);

    //       var paylods={
    //         projectname: "COD Management",
    //         type: "web",
    //         userid: parseInt(userdetail.userid),
    //         username: userdetail.username,
    //         routeurl: 'deleteSVCLedgerEntry',
    //         meta:{
    //           event:'deleteSVCLedgerEntry',
    //           data:{
    //             req:this.input,
    //             res:''
    //           }
    //         }
    //       };

    //       axios.post(apiUrl.iptracker_url,paylods);


    //       this.$alertify.success(response.data.msg);
    //       await this.GetSVCledgerData();
    //       await this.GetShipmentUpdate();
    //     } else {
    //       this.$alertify.error(response.data.msg)
    //     }
    //   })
    //   .catch((httpException) => {
    //       console.error('exception is:::::::::', httpException); this.isLoading = false; this.$alertify.error('Error Occured');
    //   });
    // },

    //to get RSC Wise RSC Owner List
    getRSCOwnerData() {
      this.rscLoading = true; this.RSCOwnerList = [];

      this.input = ({ hubid: this.localhubid });
      axios({
          method: 'POST',
          url: apiUrl.api_url + 'getHubRSCOwnerDetails',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer '+this.myStr
          }
        })
        .then(result => {
          this.rscLoading = false;

          if(result.data.code == 200){
            this.RSCOwnerList = result.data.RSCOwnerArr;
          }
        }, error => {
          this.rscLoading = false; console.error(error);
        })
    },

    setRSCOwner(index){

      this.RSCOwner = this.depositSlips[index]['RSCOwner'];

      if(this.RSCOwner) {
       this.depositSlips.forEach((element, index1) => {
          if(index1 !== index) element['RSCOwner'] = this.RSCOwner;
       });          
      }

      this.GetSVCledgerData();

      if(this.RSCOwner && (this.RSCOwner.EffectiveToDate < this.DeliveryDate)){

	      this.isFnF = true;

        this.closingBalance = this.TolatCollection = this.pendingCODAmt = this.yesterdayCODAmt = this.exceptionAmount = 0;
        this.penAmtLoading = true; this.disableButton = true;
        this.financeoutstanding = 0;
        this.input = ({
          EffectiveToDate: this.RSCOwner.EffectiveToDate,
          hubid: this.localhubid
        })

        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'rscvendorpendingamt',
            'data': this.input,
            headers: {
                'Authorization': 'Bearer '+this.myStr
            }
        })
        .then(result => {
          if(result.data.code == 200){
            this.TolatCollection = this.pendingCODAmt = parseFloat(Math.round(result.data.data.closingbalance));
            this.BatchID         = (result.data.data.batchid != 0 && result.data.data.batchid != null) ? result.data.data.batchid : this.BatchID;
            this.financeoutstanding = parseInt(Math.round(result.data.data.financeclosingamt))
          }

          this.penAmtLoading = false; this.disableButton = false;
        }, error => {
          this.penAmtLoading = false; console.error(error);
        })
      }else{ this.isFnF = false; this.GetShipmentUpdate(); }
    },

    srabscChange(index, event){
      this.srabscarr[index]['srName'] = this.getSRName(event.target.value)
    },

    srtpSrChange(index, event){
      let item = this.srtpsrPendingClosureList.find(item => item.SRID === event.target.value);
      this.srtpsrarr[index]['srName'] = item.SRName;
    },
    
    getSRName(id) {
      let item = this.pendingClosureList.find(item => item.SRID === id);
      return item.SRName;
    },

    getSRList(type = null) {
      this.input = ({
        hubid:[this.localhubid],
        userRole:this.userRole ? this.userRole : '',
        userid:this.localuserid == undefined ? null : String(this.localuserid)
      })

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'getSRClosureStatus',
        data: this.input,
        headers: {
          'Authorization': 'Bearer '+this.myStr
        }
      })
      .then(result => {
        this.pendingClosureList  = [];

        if(result.data.code == 200){
          this.pendingClosureList = result.data.data.pending;
          this.totalSum = this.pendingClosureList.reduce((acc, item) => acc + item.totalCOD, 0);
          // console.log(this.totalSum, ">>>>>>>>>>>>>>>>");
          this.srtpsrPendingClosureList = [...this.pendingClosureList, {SRID: '0000', SRName: 'Other' }];
          this.srPenAmtLoading=false;
        }else{
          this.srPenAmtLoading=false;
        }

        // axios({
        //   method: 'POST',
        //   url: apiUrl.api_url + 'getPreviouseSRAbscondingDetails',
        //   data: {hubid:[this.localhubid]},
        //   headers: {
        //     'Authorization': 'Bearer '+this.myStr
        //   }
        // }) .then(resp => {
        //   if (resp.data.code == 200) {
        //     // Merge lists and remove duplicates by srid
        //     const mergedList = [...this.pendingClosureList, ...resp.data.data];
        //     this.pendingClosureList = mergedList.filter(
        //       (item, index, self) => 
        //         index === self.findIndex((t) => t.SRID === item.SRID)
        //     );
        //   }
        // })
        
      }, error => {
        console.error(error)
        this.$alertify.error('Error Occured to load SR Owners');
      })
    },

    addNewSR() {
      this.srabscarr.push({
        awbNo: '',
        srId: '',
        srName: ''
      }) 
    },

    removeSR(index) {
      this.srabscarr.splice(index, 1);
    },

    addSrtpNewSR() {
      this.srtpsrarr.push({
        srAmt: '',
        srId: '',
        srName: ''
      }) 
    },

    removeSrtpSR(index) {
      this.srtpsrarr.splice(index, 1);
    },

    addCassnatSR() {
      this.cassnatarr.push(
        {         
          awbNo: '',
          srId: '',
          srName: ''
        }
      )
   },

   removeCassnatSR(index) {
    this.cassnatarr.splice(index, 1);
    this.cassnatAWBNoError[index] = ''
   },


   srCasChange(index, event){
    this.cassnatarr[index]['srName'] = this.getSRName(event.target.value)
   },

   onUploadAttachment(event) {
      this.srtptsvcfile = event.target.files[0];
   },

   generateUrl(key) {
      this.input = ({
        BatchID : '',
        Reason : '',
        FileName: this.fullyDecode(key),
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getfilelist',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      })
      .then(result => {
        const a = document.createElement('a');
        a.href = result.data.data;
        a.download = ''; // You can set a custom file name here
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }, error => {
        this.disableButton = false; this.ReasonLoading = false; this.DepositLoading = false;
        console.error(error)
      })
   },

   toggleCollapse(index) {
     this.isCollapsed= this.isCollapsed === index ? null : index;
   },

  async addNewDepositSlip() {
    if(this.depositSlips.length <=9) {
      await this.depositSlips.push(
        {
          RSCOwner: this.depositSlips.length > 0 ? this.depositSlips[this.depositSlips.length-1]['RSCOwner']: '',
          DeliveryDate: '',
          DepositDate: '',
          Deposit_Amount: '',
          DepositType: '',
          BankList: [],
          BankMasterId: '',
          TransactionID: '',
          exception: '',
          exceptionAmount: '',
          DepositSlip: '',
          denominationList: [],
          uploadFileList: [],
          tot_amt: 0,
          DenominationArr: []
        }
      )

      this.depositSlips[this.depositSlips.length-1].denominationList =  this.DenominationList;
      this.depositSlips[this.depositSlips.length-1].DeliveryDate =  this.DeliveryDate;
      this.isCollapsed = this.depositSlips.length-1
    } else {
      this.$alertify.error("You can add a maximum of 10 slips.");
    }
  
   },

   removeDepositSlip(index) {
    this.depositSlips.splice(index, 1);
    this.isCollapsed = this.depositSlips.length - 1
   },
   
   downloadCSV() {
    const headers = ["Hub Name","SR Name", "Pending Amount"];
    const rows = this.pendingClosureList.map(item => [this.localhubname, item.SRName, item.totalCOD]);

    // Optional: add total row at the end
    rows.push(["","Total", this.totalSum]);

    // Convert array of arrays into CSV string
    const csvContent =
      [headers, ...rows]
        .map(e => e.map(v => `"${v}"`).join(","))  // Quote each value and join with commas
        .join("\n");

    // Create a blob and download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "pending_closure.csv");
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  },
   onAwbInput() {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.fetchShipmentAmount(this.awbArr)
      }, 700)
  },
    async fetchShipmentAmount() {
      try {
        if (!this.habridpiAWBNo) return
        let awbArr = this.habridpiAWBNo
          .split(',')
          .map(a => a.trim())
          .filter(a => a)

        if (awbArr.length === 0) return
        this.loadingAwb = true

        const response = await axios({
          method: 'POST',
          url: apiUrl.api_url + 'getShipmentAmt',
          data: {
            hubId: this.localhubid,
            shippingId: awbArr
          },
          headers: {
            Authorization: 'Bearer ' + this.myStr
          }
        })

        if (response.data.code === 200) {
          this.habridpiAMT = response.data.totalAmount || 0
          this.nonIsHybrid = response.data.nonHybridShipments || []
          this.invalidShipments = response.data.invalidShipments || []
          this.invalidShipmentsMsg = ''
          this.disableButton =
            this.invalidShipments.length > 0 ||
            this.nonIsHybrid.length > 0
        } else if (response.data.code === 403) {
          this.habridpiAMT = 0;
          this.nonIsHybrid = [];
          this.invalidShipments = response.data.invalidShipments || [];
          this.invalidShipmentsMsg = response.data.message || '';
          this.disableButton = this.invalidShipments.length > 0;

          if (this.invalidShipments.length > 0) {
            const invalidIds = Array.isArray(this.invalidShipments)
              ? this.invalidShipments.map(id => typeof id === 'object' ? id.ShippingID : id).join(', ')
              : this.invalidShipments;
            this.$alertify.error('Invalid Shipping IDs: ' + invalidIds);
          }
        }

      } catch (err) {
        console.error("API error", err)
        this.$alertify.error('Error Occured ...!!')
      }
  }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/svcclosurep2p/svcclosurep2p.component.js